<template>
  <div>
    <div
      class="flex flex-shrink-0 select-none items-center space-x-2"
      :class="{ 'opacity-50': disabled }"
    >
      <input
        :id="id || internalId"
        :checked="isChecked"
        :value="value"
        type="checkbox"
        :name="name"
        :disabled="disabled"
        class="size-5 shrink-0 border border-primary text-white transition-all checked:border-primary enabled:cursor-pointer"
        @change="updateInput"
      />
      <label v-if="label || hasLabel" :for="id || internalId">
        <slot name="label">
          <span class="text-xs font-light">{{ label }} </span>
        </slot>
      </label>
    </div>

    <FieldHint
      v-if="!hideDetails"
      :error="Boolean(errorMessage)"
      :message="errorMessage || hint"
    />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import FieldHint from "~/components/shared/FieldHint.vue";

const props = withDefaults(
  defineProps<{
    modelValue: any;
    name?: string;
    value?: string | number | boolean;
    trueValue?: string | number | boolean;
    falseValue?: string | number | boolean;
    id?: string;
    label?: string;
    hideDetails?: boolean;
    disabled?: boolean;
    hint?: string;
  }>(),
  {
    name: undefined,
    value: "",
    trueValue: true,
    falseValue: false,
    id: "",
    label: "",
    hint: "",
  },
);

const emit = defineEmits(["update:modelValue"]);

const slots = useSlots();

// const internalId = generateString();
const internalId = useId();

const { errorMessage, handleChange } = useField(
  props.name || internalId,
  undefined,
  {
    initialValue: props.modelValue,
  },
);

const isChecked = computed(() => {
  if (props.modelValue instanceof Array) {
    return props.modelValue.includes(props.value);
  }
  return props.modelValue === props.trueValue;
});

const hasLabel = computed(() => {
  return !!slots.label;
});

function updateInput(event: Event) {
  const isChecked = (event.target as HTMLInputElement).checked;
  if (props.modelValue instanceof Array) {
    const newValue = [...props.modelValue];
    if (isChecked) {
      newValue.push(props.value);
    } else {
      newValue.splice(newValue.indexOf(props.value), 1);
    }
    if (props.name) {
      handleChange(props.modelValue);
    }
    emit("update:modelValue", newValue);
  } else {
    if (props.name) {
      // handleChange(props.modelValue);
      handleChange(isChecked ? props.trueValue : props.falseValue);
    }
    emit("update:modelValue", isChecked ? props.trueValue : props.falseValue);
  }
}
</script>
